import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from '../actions/auth';
import './login.css';
import '../index.css';
import { Link } from 'react-router-dom';
import { GoogleSignInButton } from '../sign_in/components/GoogleSignInButton'


export class Login extends Component {

  state = {
    username: '',
    password: '',
    error: false
  };

  static propTypes = {
    login: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.login(this.state.username, this.state.password);
  };

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/" />;
    }
    const { username, password } = this.state;
    return (

      <div className="container-sm sign-in-form-container">
        <div className="d-flex justify-content-center sign-in-title">
          <p className="headline">Sign In</p>
        </div>
        <div className="d-flex justify-content-center">
          <form onSubmit={this.onSubmit} data-testid="login">
            <div className="mb-4 text-start">
              <label className="form-label body">Username</label>
              <input
                type="username"
                name="username"
                className="form-control field"
                data-testid="inputUsername"
                aria-describedby="usernameHelp"
                onChange={this.onChange}
                value={username}
                required
              />
            </div>

            <div className="mb-4 text-start">
              <label className="form-label body">Password</label>
              <input
                type="password"
                name="password"
                className="form-control field"
                data-testid="inputPassword"
                onChange={this.onChange}
                value={password}
                required
              />
            </div>

            <div className="d-flex justify-content-center">
              <button type="submit" className="button button-login">
                Sign In
                  </button>
            </div>

            <div className="d-flex justify-content-center mb-5">
              <GoogleSignInButton />
            </div>
          </form>
        </div>

        <div className="d-flex justify-content-center footnote" >
          {/* body daftarnya di bold */}
          <p>Baru di Liwat?
                    <Link to="/register" className="text-decoration-none login">Daftar</Link>
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { login })(Login);